const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_jI0fK4Kq0",
  aws_user_pools_web_client_id: "2mmkipug6pd0neg9f5v8krfusb",
  oauth: {
    domain: "https://beta-dominio-user-pool.auth.us-east-2.amazoncognito.com",
  },
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [
    "NAME",
    "FAMILY_NAME",
    "EMAIL",
    "LOCALE",
    "ADDRESS"
  ],
  aws_cognito_mfa_configuration: "ON",
  aws_cognito_mfa_types: ["TOTP"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  aws_cognito_verification_mechanisms: ["EMAIL"]
};

export default awsmobile;
